export default function updateAction(state, payload) {
  return {
    ...state,
    akt: {
      ...state.akt,
      ...payload,
    },
  };
}
